import React, { Component, Fragment } from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "../styles"
import { connect } from "react-redux"
import Context from "../context"
import {
  Typography,
  DialogContent,
  FormControl,
  InputLabel,
  Input,
  Icon,
  Chip,
  Avatar,
  Checkbox,
  Hidden,
  Grid,
} from "@material-ui/core"
import AutoComplete from "../../AutoComplete"
import update from "immutability-helper"
import MaskedInput from "react-text-mask"
import { getUser, toggleCreateUserDialog } from "../../../actions/users"
import { searchShootsCrew } from "../../../actions/shoots"

import {
  listCrew,
  searchCrew,
  clearCrewFromChip,
  loadingCrew,
  loadingCrewFromChip,
} from "../../../actions/crew"

import CrewRateSlate from "../../CrewRateSlate"

function MInput(props) {
  const { inputRef, ...other } = props
  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null)
      }}
      mask={["%", /\d/, /\d/]}
      placeholderChar={"\u2000"}
    />
  )
}

class Three extends Component {
  state = {
    percentage: 12,
    searchCrew: [],
    currentPage: 1,
  }

  async componentDidMount() {
    this.props.setRef(this)
    await this.props.dispatch(listCrew(this.state.currentPage)).then(res => {
      this.props.dispatch(loadingCrew)
    })
  }

  selectPosition = id => {
    const { context, props } = this
    const { setState, roles } = props
    const role = roles.find(x => x.id === id)
    setState(
      update(context, {
        shoot: {
          newPosition: {
            position: {
              $set: role,
            },
          },
        },
      })
    )
    this.getCrew(role, context.shoot.location)
    // document.getElementById("position-client-rate").focus()
    const query = {
      currentPage: { currentPage: this.state.currentPage },
      roles: { name: role.name },
    }
    // new view load crew card on selecting position
    this.props.dispatch(loadingCrewFromChip())
    this.props.dispatch(clearCrewFromChip())
    this.props.dispatch(searchCrew(query))
    //  this.props
    // .dispatch(listCrew(query))
    // .then(res => {
    //   this.props.dispatch(loadingCrew)
    // })
  }

  getCrew = (role, { lat, lon }) => {
    const search = {
      roles: {
        name: role.name,
      },
      locations: {
        lat,
        lon,
      },
    }
    this.props
      .dispatch(searchShootsCrew(search))
      .then(res => {
        this.setState({ searchCrew: res })
      })
      .catch(err => {
        this.setState({ searchCrew: [] })
      })
  }

  selectDefaultCrewPosition = (id, i) => {
    const { context, props } = this
    const { setState, roles } = props
    const role = roles.find(x => x.id === id)

    setState(
      update(context, {
        shoot: {
          defaultCrews: {
            [i]: {
              shootRole: {
                id: { $set: role.id },
                name: { $set: role.name },
              },
            },
          },
        },
      })
    )
  }

  setDefaultCrewRate = (e, i, name) => {
    const { context, props } = this
    const { setState } = props
    const n = Number
    if (name === "client_rate") {
      setState(
        update(context, {
          shoot: {
            defaultCrews: {
              [i]: {
                shootRole: {
                  client_rate: {
                    $set: e.target.value,
                  },
                  crew_rate: {
                    $set:
                      n(e.target.value) -
                      n(e.target.value) *
                      n(context.shoot.defaultCrews[i].shootRole.percentage) *
                      0.01,
                  },
                },
              },
            },
          },
        })
      )
    } else {
      setState(
        update(context, {
          shoot: {
            defaultCrews: {
              [i]: {
                shootRole: {
                  crew_rate: {
                    $set: e.target.value,
                  },
                  percentage: {
                    $set:
                      (1 -
                        n(e.target.value) /
                        n(
                          context.shoot.defaultCrews[i].shootRole.client_rate
                        )) *
                      100,
                  },
                },
              },
            },
          },
        })
      )
    }
  }

  setRate = (e, i, name) => {
    const { props, context } = this
    const { setState } = props
    const n = e => Number(e)
    if (name === "client_rate") {
      setState(
        update(context, {
          shoot: {
            roles: {
              [i]: {
                crew_rate: {
                  $set:
                    n(e.target.value) -
                    n(e.target.value) * (n(this.state.percentage) * 0.01),
                },
                client_rate: {
                  $set: e.target.value,
                },
              },
            },
          },
        })
      )
    } else {
      setState(
        update(context, {
          shoot: {
            roles: {
              [i]: {
                crew_rate: {
                  $set: e.target.value,
                },
              },
            },
          },
        })
      )
      this.setState({
        percentage:
          (1 - n(e.target.value) / n(context.shoot.newPosition.client_rate)) *
          100,
      })
    }
  }

  handleSwitch = () => {
    const { props, context } = this
    const { setState } = props
    setState(
      update(context, {
        shoot: {
          newPosition: {
            switch: {
              $set: !context.shoot.newPosition.switch,
            },
          },
        },
      })
    )
  }

  addPosition = () => {
    const { props, context } = this
    const { setState } = props
    const { newPosition } = context.shoot
    this.setState({ searchCrew: [] })
    if (context.shoot.newPosition.user) {
      return this.addDefaultCrew()
    }
    setState(
      update(context, {
        shoot: {
          newPosition: {
            client_rate: {
              $set: 0,
            },
            crew_rate: {
              $set: 0,
            },
            switch: {
              $set: false,
            },
            position: {
              $set: null,
            },
            user: {
              $set: null,
            },
          },
          roles: {
            $push: [
              {
                client_rate: newPosition.client_rate,
                crew_rate: newPosition.crew_rate,
                switch: newPosition.switch,
                position: newPosition.position,
              },
            ],
          },
        },
      })
    )
    // focus autocopmlete after adding new position
    try {
      document.querySelector("#add-position-input input[type=text]").focus()
    } catch (err) { }
  }

  setPercentage = (e, i) => {
    const { props, context } = this
    const { setState } = props
    const n = Number
    let value = e.target.value.replace("%", "")
    if (value.toString()[0] === "0") {
      value = value.substring(1)
    }
    // this.setState({ percentage: value })
    // if (context.shoot.newPosition.client_rate)
    if (context.shoot.roles[i] && context.shoot.roles[i].client_rate) {
      setState(
        update(context, {
          shoot: {
            roles: {
              [i]: {
                crew_rate: {
                  $set:
                    n(context.shoot.roles[i].client_rate) -
                    n(context.shoot.roles[i].client_rate) * (n(value) / 100),
                },
              },
            },
          },
        })
      )
    }
  }

  setDefaultCrewavailable = (e, i) => {
    const { props, context } = this
    const { setState } = props
    if (
      context.shoot.defaultCrews[i] &&
      context.shoot.defaultCrews[i].shootRole
    ) {
      setState(
        update(context, {
          shoot: {
            defaultCrews: {
              [i]: {
                shootRole: {
                  available: {
                    $set: !context.shoot.defaultCrews[i].shootRole.available,
                  },
                  requested: {
                    $set: !context.shoot.defaultCrews[i].shootRole.requested,
                  },
                },
              },
            },
            markConfirmDialog: {
              $set: !context.shoot.markConfirmDialog,
            },
          },
        })
      )

    }
  }

  setDefaultCrewPercentage = (e, i) => {
    const { props, context } = this
    const { setState } = props
    const n = Number
    let value = e.target.value.replace("%", "")
    if (value.toString()[0] === "0") {
      value = value.substring(1)
    }
    if (
      context.shoot.defaultCrews[i] &&
      context.shoot.defaultCrews[i].shootRole &&
      context.shoot.defaultCrews[i].shootRole.client_rate
    ) {
      setState(
        update(context, {
          shoot: {
            defaultCrews: {
              [i]: {
                shootRole: {
                  percentage: {
                    $set: value,
                  },
                  crew_rate: {
                    $set:
                      n(context.shoot.defaultCrews[i].shootRole.client_rate) -
                      n(context.shoot.defaultCrews[i].shootRole.client_rate) *
                      (n(value) / 100),
                  },
                },
              },
            },
          },
        })
      )
    } else {
      setState(
        update(context, {
          shoot: {
            defaultCrews: {
              [i]: {
                shootRole: {
                  percentage: {
                    $set: value,
                  },
                },
              },
            },
          },
        })
      )
    }
  }

  selectUser = async id => {
    const { context, props } = this
    const { setState } = props
    const { newPosition } = context.shoot
    if (newPosition && newPosition.position) {
      if (typeof id.id === "number") {
        await setState(
          update(context, {
            shoot: {
              newPosition: {
                user: {
                  $set: props.users.find(x => x.id === id.id),
                },
              },
            },
          })
        )
        this.addPosition()
        // let query = {}
        // const full_name = id.full_name
        // query.users = {full_name}
        // const currentPage = this.state.currentPage
        // query.currentPage = { currentPage }
        // this.props.dispatch(clearCrewFromChip())
        // this.props.dispatch(searchCrew(query))
      } else {
        props.dispatch(toggleCreateUserDialog(true, {}))
      }
    } else {
      // focus autocopmlete add position if there is no position
      try {
        document.querySelector("#add-position-input input[type=text]").focus()
      } catch (err) { }
    }
  }

  addDefaultCrew = () => {
    const { context, props } = this
    const { setState } = props
    const { shoot } = context
    const { newPosition } = shoot
    const percentage = this.state.percentage
    this.props.dispatch(getUser(newPosition.user.id, false)).then(res => {
      this.setState({ percentage: 12 })
      setState(
        update(context, {
          shoot: {
            newPosition: {
              client_rate: {
                $set: 0,
              },
              crew_rate: {
                $set: 0,
              },
              switch: {
                $set: false,
              },
              position: {
                $set: null,
              },
              user: {
                $set: null,
              },
              requested: {
                $set: false,
              },
              available: {
                $set: false,
              },
            },
            defaultCrews: {
              $push: [
                {
                  shootRole: {
                    id: shoot.newPosition.position.id,
                    client_rate: shoot.newPosition.client_rate,
                    crew_rate: shoot.newPosition.crew_rate,
                    name: newPosition.position.name,
                    percentage,
                    available: shoot.newPosition.available,
                    requested: shoot.newPosition.requested,
                  },
                  id: shoot.newPosition.user.id,
                  ...res,
                },
              ],
            },
          },
        })
      )
    })

    // this.props.dispatch(clearCrewFromChip())
  }

  getDefaultCrew = e => { }

  render() {
    const { context, props } = this
    const { classes, setState, roles } = props
    const { newPosition } = context.shoot
    const positionCrew = c => {
      return c.map((crew, index) => (
        <Grid container direction="row" key={index}>
          <div data-id={crew.id} className={this.props.classes.crewCardWrapper}>
            <CrewRateSlate
              crew={crew}
              currentUser={this.props.authentication.authenticatedUser}
              accessLevel={this.props.accessLevel}
              activeCompany={this.props.activeCompany}
              onOpenProfile={() =>
                context.shoot.defaultCrews &&
                  context.shoot.defaultCrews.some(x => x.id === crew.id)
                  ? setState(
                    update(context, {
                      shoot: {
                        defaultCrews: {
                          [context.shoot.defaultCrews.findIndex(
                            x => x.id === crew.id
                          )]: {
                            shootRole: {
                              $set: null,
                            },
                          },
                          $splice: [
                            [
                              context.shoot.defaultCrews.findIndex(
                                x => x.id === crew.id
                              ),
                              1,
                            ],
                          ],
                        },
                      },
                    })
                  )
                  : this.selectUser(crew)
              }
              onOpenBookingDialog={() => {

              }}
              onOpenMessageDrawer={this.openMessageDrawer}
              ratingChanged={val => this.ratingChanged(val, crew)}
              isPositionSearch={this.state.selectedRole || false}
              onRemoveFromCompany={this.removeFromCompany}
              history={this.props.history}
            />
          </div>

          <div style={{ flexDirection: "row" }}>
            <div className={classes.PositionInfo}>
              <Typography component="p" className={classes.noteLineTextCrew}>
                {crew.first_name + " " + crew.last_name}
              </Typography>
              {/* <Typography
                                component="p"
                                className={
                                    classes.positionText
                                }
                            >
                                {crew.shootRole && crew.shootRole.name}
                            </Typography> */}

              {crew.shootRole && crew.shootRole.id ? (
                <Typography component="p" className={classes.positionText}>
                  {crew.shootRole && crew.shootRole.name}
                </Typography>
              ) : (
                <div style={{ minWidth: "200px", marginRight: "32px" }}>
                  <AutoComplete
                    placeholder="Search Position"
                    // onChange={this.selectPosition}
                    onChange={value =>
                      this.selectDefaultCrewPosition(value, index)
                    }
                    suggestions={roles}
                    labelKey="name"
                    showValue
                    value={newPosition.position}
                    prop={this.props}
                  />
                </div>
              )}
            </div>

            {/* <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ maxWidth: "100px", margin: "8px" }}>
                <FormControl style={{ maxWidth: "100px" }}>
                  <InputLabel>
                    {this.props.activeCompany ? "Client Rate" : "Crew Rate"}
                  </InputLabel>
                  <Input
                    id="defaultCrew-client-rate"
                    type="number"
                    value={
                      crew.shootRole && crew.shootRole.client_rate
                        ? crew.shootRole.client_rate
                        : ""
                    }
                    onChange={e =>
                      this.setDefaultCrewRate(e, index, "client_rate")
                    }
                    disabled={!crew.shootRole}
                  />
                </FormControl>
              </div>

              {this.props.activeCompany && (
                <div style={{ maxWidth: "100px", margin: "8px" }}>
                  <FormControl style={{ maxWidth: "100px" }}>
                    <InputLabel>Crew Rate</InputLabel>
                    <Input
                      id="defaultCrew-crew-rate"
                      type="number"
                      value={
                        crew.shootRole && crew.shootRole.crew_rate
                          ? crew.shootRole.crew_rate
                          : ""
                      }
                      onChange={e =>
                        this.setDefaultCrewRate(e, index, "crew_rate")
                      }
                      disabled={!crew.shootRole}
                    />
                  </FormControl>
                </div>
              )}

              {this.props.activeCompany && (
                <div style={{ maxWidth: "100px", margin: "8px" }}>
                  <FormControl style={{ maxWidth: "50px" }}>
                    <InputLabel>%</InputLabel>
                    <Input
                      value={
                        crew.shootRole && crew.shootRole.percentage
                          ? Math.round(crew.shootRole.percentage)
                          : ""
                      }
                      onChange={e => this.setDefaultCrewPercentage(e, index)}
                      inputComponent={MInput}
                    />
                  </FormControl>
                </div>
              )}
            </div> */}
          </div>

          <div
            style={{
              marginLeft: "8px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Checkbox
              style={{ fontSize: "14px", paddingRight: "4px" }}
              checked={crew.shootRole && crew.shootRole.available}
              onChange={e => {
                this.setDefaultCrewavailable(e, index)
              }}
              disabled={!crew.shootRole}
            />
            <p style={{ fontSize: "10px" }}>Confirmed</p>
          </div>
        </Grid>
      ))
    }

    const positions = (data, crew) => {
      const extra = crew ? positionCrew(crew) : []
      // shot selected crew first
      return extra.concat(
        data.map((x, i) => {
          return (
            <Grid
              container
              direction="row"
              key={i}
              style={{
                display: "flex",
                marginTop: "16px",
                marginLeft: "65px",
                alignItems: "center",
              }}
            >
              <Chip
                avatar={
                  <Avatar
                    className={classes.closeAvatar}
                    onClick={e =>
                      setState(
                        update(context, {
                          shoot: {
                            roles: {
                              $splice: [[i, 1]],
                            },
                          },
                        })
                      )
                    }
                  >
                    <Icon className={classes.closeIcon}>close</Icon>
                  </Avatar>
                }
                color="primary"
                label={x.position && x.position.name}
                style={{ color: "white" }}
              />
              <FormControl style={{ marginLeft: "32px", maxWidth: "100px" }}>
                <InputLabel>Client Rate</InputLabel>
                <Input
                  value={x.client_rate}
                  type="number"
                  onChange={e => this.setRate(e, i, "client_rate")}
                />
              </FormControl>
              <FormControl style={{ marginLeft: "32px", maxWidth: "100px" }}>
                <InputLabel>Crew Rate</InputLabel>
                <Input
                  value={x.crew_rate}
                  type="number"
                  onChange={e => this.setRate(e, i, "crew_rate")}
                />
              </FormControl>
              <FormControl style={{ marginLeft: "32px", maxWidth: "100px" }}>
                <InputLabel>%</InputLabel>
                <Input
                  // value={
                  //     x.shootRole && x.shootRole.percentage
                  //         ? Math.round(x.shootRole.percentage)
                  //         : ""
                  // }
                  value={
                    x.client_rate &&
                      x.crew_rate &&
                      x.client_rate !== "" &&
                      x.crew_rate !== "" &&
                      x.client_rate !== 0 &&
                      x.crew_rate !== 0
                      ? 100 -
                      (Number(x.crew_rate) / Number(x.client_rate)) * 100
                      : Math.round(this.state.percentage)
                  }
                  onChange={e => this.setPercentage(e, i)}
                  // onChange={this.setPercentage}
                  inputComponent={MInput}
                />
              </FormControl>
            </Grid>
          )
        })
      )
    }
    return (
      <Fragment>
        {/* WEB VIEW */}
        <Hidden smDown>
          {/* title section */}
          <div className={classes.title}>
            <DialogContent>
              <Typography gutterBottom className={classes.white} variant="h6">
                Add Crew
              </Typography>
            </DialogContent>
          </div>
          {/* end title section */}
          {/* positions section */}
          <DialogContent>
            <div className={classes.margin}>
              {positions(context.shoot.roles, context.shoot.defaultCrews)}
            </div>
          </DialogContent>
        </Hidden>
        {/* MOBILE VIEW */}
        <Hidden mdUp>
          {/* title section */}
          <div className={classes.title}>
            <DialogContent>
              <Typography gutterBottom className={classes.white} variant="h6">
                Add Crew
              </Typography>
            </DialogContent>
          </div>
          {/* end title section */}
          {/* positions section */}
          <DialogContent style={{ paddingTop: 40 }}>
            {positions(context.shoot.roles, context.shoot.defaultCrews)}
            {/* <div className={classes.positionsWrapper}> */}
          </DialogContent>
        </Hidden>
      </Fragment>
    )
  }
}

Three.contextType = Context
// controlls disabled prop of next/save button
Three.allowNext = state => {
  // console.log('state.shoot.defaultCrews', state.shoot.defaultCrews)
  // state.shoot.defaultCrews && state.shoot.defaultCrews.map((crew, index) => (
  //  return crew.
  // ))
  return false
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication,
    open: state.shoots.showDialog,
    roles: state.misc.roles,
    users: state.misc.users,
    crew: state.crew,
    locations: state.misc.locations,
    equipment: state.misc.equipment,
    activeCompany: state.companies.activeCompany,
    accessLevel: state.companies.accessLevel,
    crewlength: state.crewlength,
    searchcrewLength: state.searchcrewLength,
    crewModal: state.users.crewModal,
    setModal: state.users.setModal,
  }
}

const connector = connect(mapStateToProps)

export default withStyles(styles, { withTheme: true })(connector(Three))
